module.exports = __webpack_public_path__ + "img/border_br.6ff3205c.svg";